(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConnectExistingTeacherToGroupController', ConnectExistingTeacherToGroupController);

    ConnectExistingTeacherToGroupController.$inject = ['debug', 'API', 'i18n', '$scope',];

    function ConnectExistingTeacherToGroupController(debug, API, i18n, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.loading = false;
        vm.teachers = [];
        vm.teachersToRender = [];
        vm.loadingState = {
            teachersAreLoading: false,
        };

        activate();

        function activate() {
            vm.group = $scope.placeholders.group;
            loadTeachers();
        }

        function loadTeachers() {
            vm.loadingState.teachersAreLoading = true;
            var promise = API.User.search({
                fk_school_id: vm.group.fk_school_id,
                user_type: 'teacher',
                expand: 'groups',
                page: 1,
                'per-page': 0,
            }).$promise;

            promise.then(function(response) {
                vm.teachers = response.items;
                angular.forEach(response.items, function(teacher) {
                    var addThis = true;
                    angular.forEach(teacher.groups, function(userGroup) {
                        if (vm.group.id === userGroup.id) {
                            addThis = false;
                        }
                    });
                    if (addThis) {
                        vm.teachersToRender.push({
                            value: teacher.id,
                            label: teacher.first_name + ' ' + teacher.last_name,
                            subLabel: teacher.id,
                        });
                    }
                });
            }, function(response) {
                window.toast({ message: i18n.get('COULD_NOT_LOAD_SCHOOL_TEACHERS'), autoRemoveTime: 5000, type: 'danger' });
                debug.log(response);
            })
            .finally(function() {
                vm.loadingState.teachersAreLoading = false;
            });
        }

        function submit() {
            API.User.addToGroup({
                id: vm.teacherIdToConnect,
                target: vm.group.id
            }).$promise.then(function () {
                window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                // Return selected teacher object
                angular.forEach(vm.teachers, function(teacher) {
                    if (teacher.id === vm.teacherIdToConnect) {
                        $scope.$parent.submit(teacher);
                    }
                });
                $scope.$parent.close();
            }, function (response) {
                vm.reject(response);
            });
        }

    }
})();